import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import _, { debounce } from 'lodash';

import { PageWrapper, Loader, Alert, Pagination } from '../../components';
import Actions, { thunks } from '../../redux/modules/products';
import DiscountModal from './components/discountModal';

class HotLooks extends React.Component {
    state = {
        toApplyDiscount: {}
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(thunks.getHotLookProducts());
    }

    viewProduct = product => {
        this.props.history.push(`/product/${product.productId}`);
    }


    removeFromHotLook = product => {
        const body = {
            isHotLook: 0,
            id: product.productId
        }
        const { dispatch } = this.props;
        dispatch(thunks.removeFromHotLook(body));
    }

    onApplyDiscount = product => {
        this.setState({ toApplyDiscount: product });
    }

    onHideDiscountModal = () => {
        this.setState({ toApplyDiscount: {} });
    }

    handleApplyDiscount = discount => {
        const { dispatch } = this.props;
        const { toApplyDiscount } = this.state;
        dispatch(thunks.editHotLook({
            discount,
            id: toApplyDiscount.productId,
        }));
        this.onHideDiscountModal();
    }


    render() {
        const {
            list,
            loading,
            error,
            updateProperty,
            nextPageToken,
            categories,
            message,
        } = this.props;
        const { toApplyDiscount } = this.state;

        return (
            <PageWrapper title="Hot Look List">
                <Loader show={loading} />
                <Alert
                    show={!!error}
                    onHide={() => updateProperty('error', '')}
                    title="Hot Looks"
                    message={error}
                />
                <div className="animated fadeIn">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">

                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Product Title</th>
                                                    <th>Category</th>
                                                    <th className="text-center">Stock</th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    list.length ? (
                                                        list.map(product => (
                                                            <tr key={product.productId}>
                                                                <td>{product.productId}</td>
                                                                <td>{product.title}</td>
                                                                <td>{(categories.find(category => category.id === product.parentCategoryId) || {}).displayName || '-'}</td>
                                                                <td className="text-center">
                                                                    <span
                                                                        className={classNames('badge badge-success', {
                                                                            // 'badge-success': product.inStock,
                                                                            // 'badge-danger': !product.inStock
                                                                        })}>
                                                                        {/* {!product.inStock && 'Not '}Available */}
                                                                        Available
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <button title="Add To Hotlook" className="btn btn-xs btn-primary ml-2" onClick={() => this.removeFromHotLook(product)}>
                                                                        <i className="fa fa-trash" />
                                                                    </button>
                                                                    <button title="Add To Hotlook" className="btn btn-xs btn-primary ml-2" onClick={() => this.onApplyDiscount(product)}>
                                                                        <i className="fa fa-plus" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center">No Records Found</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Alert
                    show={!!message}
                    onHide={() => updateProperty('message', '')}
                    title="Hot Looks"
                    message={message}
                />
                 <DiscountModal
                    show={!isEmpty(toApplyDiscount)}
                    data={toApplyDiscount}
                    onHide={this.onHideDiscountModal}
                    handleApplyDiscount={this.handleApplyDiscount}
                />
            </PageWrapper>
        )
    }
}

const mapStateToProps = ({
    products: {
        loading,
        error,
        list,
        nextPageToken,
        categories,
        subCategories,
        parentCategoryID,
        parentSubCategoryID,
        message,
    },
}) => ({
    loading,
    error,
    list,
    nextPageToken,
    categories,
    subCategories,
    parentCategoryID,
    parentSubCategoryID,
    message,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(HotLooks)